export default {"src":"/_next/static/media/Twitter.f13300d5.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};